<template>
  <section id="passenger" class="section">
    <div class="container">
      <div class="columns is-mobile is-centered close">
        <div class="column is-full has-text-right pr-0">
          <button class="button ios" type="button" @click="$emit('close')">
            <b-image
              :src="require('@/assets/images/ico-close-yellow.png')"
              alt="Next"
            ></b-image>
          </button>
        </div>
      </div>
      <div class="columns is-mobile detail">
        <div class="column is-3 photo pl-0 pr-0 pt-0">
          <b-image
            :src="imgpic"
            :src-fallback="require('@/assets/images/no-photo-blue.png')"
            alt="Next"
          ></b-image>
        </div>
        <div class="column is-8 is-offset-1 info">
          <div class="columns is-multiline is-mobile">
            <div class="column is-full name pl-0">
              <p class="has-text-caxton-blue">
                <span class="lastname has-text-weight-bold is-size-2">
                  {{ tr.nombrecompleto.split(",")[0] }}
                </span>
                <span class="firstname has-text-weight-bold is-size-2">
                  {{ tr.nombrecompleto.split(",")[1] }}
                </span>
                <span class="age is-size-2 has-text-weight-light">
                  {{ tr.codigocurso }}-{{ tr.tutoria }}
                </span>
              </p>
            </div>
            <div class="column is-full icons">
              <b-image
                :src="
                  require('@/assets/images/ico-alergias-' +
                    (tr.iconalergiasoenfermedades ? 'yellow' : 'grey') +
                    '.png')
                "
                v-show="tr.iconalergiasoenfermedades"
                alt="Alergias o Enfermedad"
              ></b-image>
              <b-image
                :src="
                  require('@/assets/images/ico-sillita-' +
                    (tr.usasilla == 1 ? 'yellow' : 'grey') +
                    '.png')
                "
                v-show="tr.usasilla == 1"
                alt="Usa silla"
              ></b-image>
              <b-image
                :src="
                  require('@/assets/images/ico-autorizado-' +
                    (tr.autorizadobajarsolo == 1 ? 'yellow' : 'grey') +
                    '.png')
                "
                alt="Autorizado bajar solo"
                v-show="tr.autorizadobajarsolo == 1"
              ></b-image>
            </div>
            <div class="column is-full observations pl-0 pr-0">
              <b-field>
                <b-input
                  v-model="tr.observaciones"
                  placeholder="Observaciones"
                  maxlength="200"
                  type="textarea"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-full medical pl-0" v-if="tr.alergias">
              <h5 class="is-size-6 has-text-caxton-orange has-text-weight-bold">
                Alergias
              </h5>
              <p
                class="has-text-caxton-blue"
                v-for="(al, index) in tr.alergias"
                :key="'alerg_' + index"
              >
                <strong>{{ al.descripcion }}</strong>
                {{ al.gravedad == "1" ? "Leve" : "Grave" }}
              </p>
            </div>
            <div
              class="column is-full medical pl-0"
              v-if="tr.descripcionmedica"
            >
              <h5 class="is-size-6 has-text-caxton-orange has-text-weight-bold">
                Descripción Médica
              </h5>
              <div>
                <p class="has-text-caxton-blue">
                  {{ tr.descripcionmedica.Datos1 }}<br />
                  {{ tr.descripcionmedica.Datos2 }}<br />
                </p>
                <strong class="has-text-caxton-blue">{{
                  tr.descripcionmedica.Gravedad == "1" ? "Leve" : "Grave"
                }}</strong>
              </div>
            </div>
            <div
              class="column is-full contact pl-0"
              v-if="tr.personasautorizadas && tr.personasautorizadas.length > 0"
            >
              <h5 class="is-size-6 has-text-caxton-orange has-text-weight-bold">
                Personas Autorizadas
              </h5>

              <div
                class="mb-1"
                v-for="(pa, index) in tr.personasautorizadas"
                :key="'persaut_' + index"
              >
                <p v-if="pa.apellidos || pa.nombre">
                  <strong>{{ pa.nombre + " " + pa.apellidos }}</strong
                  ><br />
                  <span class="tags has-addons">
                    <span class="tag has-text-caxton-blue">{{
                      pa.relacion
                    }}</span>
                    <span class="tag" v-show="pa.dni != ''"> {{ pa.dni }}</span>
                  </span>
                </p>
              </div>
            </div>
            <div class="column is-full contact pl-0">
              <h5 class="is-size-6 has-text-caxton-orange has-text-weight-bold">
                Tutores
              </h5>
              <div class="columns">
                <div class="column">
                  <p class="mb-1">
                    <span class="field is-grouped is-grouped">
                      <span class="mr-1">{{
                        tr.tutores.tutor1.nombretutor
                      }}</span>
                      <span
                        class="control"
                        v-show="tr.tutores.tutor1.fijotutor != ''"
                      >
                        <span class="tags has-addons">
                          <span class="tag"
                            ><b-icon icon="phone" size="is-small"></b-icon
                          ></span>
                          <a
                            :href="'tel:' + tr.tutores.tutor1.fijotutor"
                            class="tag is-primary"
                          >
                            {{ tr.tutores.tutor1.fijotutor }}</a
                          >
                        </span>
                      </span>
                      <span
                        class="control"
                        v-show="tr.tutores.tutor1.moviltutor != ''"
                      >
                        <span class="tags has-addons">
                          <span class="tag"
                            ><b-icon icon="cellphone" size="is-small"></b-icon
                          ></span>
                          <a
                            :href="'tel:' + tr.tutores.tutor1.moviltutor"
                            class="tag is-success"
                          >
                            {{ tr.tutores.tutor1.moviltutor }}</a
                          >
                        </span>
                      </span>
                    </span>
                  </p>
                </div>
                <div class="column">
                  <p class="mb-1">
                    <span class="field is-grouped is-grouped">
                      <span class="mr-1">{{
                        tr.tutores.tutor2.nombretutor
                      }}</span>
                      <span
                        class="control"
                        v-show="tr.tutores.tutor2.fijotutor != ''"
                      >
                        <span class="tags has-addons">
                          <span class="tag"
                            ><b-icon icon="phone" size="is-small"></b-icon
                          ></span>
                          <a
                            :href="'tel:' + tr.tutores.tutor2.fijotutor"
                            class="tag is-primary"
                          >
                            {{ tr.tutores.tutor2.fijotutor }}</a
                          >
                        </span>
                      </span>
                      <span
                        class="control"
                        v-show="tr.tutores.tutor2.moviltutor != ''"
                      >
                        <span class="tags has-addons">
                          <span class="tag"
                            ><b-icon icon="cellphone" size="is-small"></b-icon
                          ></span>
                          <a
                            :href="'tel:' + tr.tutores.tutor2.moviltutor"
                            class="tag is-success"
                          >
                            {{ tr.tutores.tutor2.moviltutor }}</a
                          >
                        </span>
                      </span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["tr", "imgpic"],
  name: "Passenger",
  methods: {}
};
</script>

<style scoped></style>
